module.exports = __webpack_public_path__ + "static/media/AccountMangement.dabfa9f1.svg";